export const ModePage = {
  INVEST_ALL: 'INVEST_ALL',
  INVEST_SELECTED: 'INVEST_SELECTED'
};

export type LoanChecked = { id: string; isChecked: boolean; isDisabled?: boolean };

export const DEFAULT_OPPORTUNITIES_PAGE = 1;
